export type GameId = 'clashofclans' | 'hayday' | 'brawlstars' | 'clashroyale'
export type ShortGameId = 'coc' | 'hd' | 'bs' | 'cr'

export const COC_PROGRESS = {
  TOWN_HALL: 0,
  TROPHIES: 1,
} as const

export const HD_PROGRESS = {
  FARM_LEVEL: 0,
} as const

export const BS_PROGRESS = {
  EXP_LEVEL: 0,
  TROPHIES: 1,
} as const

export const CR_PROGRESS = {
  ARENA_NAME: 0,
  TROPHIES: 1,
} as const

const gameIds: readonly string[] = ['clashofclans', 'hayday', 'brawlstars', 'clashroyale'] as const
export const isGameId = (s: string): s is GameId => gameIds.includes(s)
